import React from 'react';
import InternationalTaxProfile from './international_tax_profile';
import InternationalTaxProfileForm from './international_tax_profile_form';

interface Props {
  newProfile: boolean;
}

export function InternationalTaxProfileContainer({ newProfile }: Props) {
  return (
    newProfile ?
      <InternationalTaxProfileForm /> :
      <InternationalTaxProfile />
  );
}

export default InternationalTaxProfileContainer;
